// PageSignupTeamV2 Component
import React from 'react'

import PageSignupTeam from '../page_signupteam/page_signupteam.jsx'
import app from '../../../app.jsx'
import SignupTeamContentv2 from '../../signup/signup_teamcontentv2/signup_teamcontentv2.jsx'

class PageSignupTeamV2 extends PageSignupTeam {
  _renderSignupContent () {
    const recaptchaEnabled = app.config.recaptcha.enabled
    return (
      <SignupTeamContentv2
        ref={this._references.signupContent}
        recaptchaEnabled={recaptchaEnabled}
        country={this.props.country}
        checkUserExists={this._checkUserExists.bind(this)}
        onSubmit={this._onSignupTeam.bind(this)}
        email={this.props.email}
      />
    )
  }
}

export default PageSignupTeamV2
